const mapStateToProps = (state) => {
    const {
        api:{
            // singleDocument,
            addingDocument,
            savingDocument,
        }={},
        user:{
            rights,
        }={},

        service:{
            Api:{
                // getSingleDocument,
                addDocument,
                saveDocument,
                actions:{
                    setSingleDocument,
                }={},
            }={}
        }={}
    } = state;
    return {
        // singleDocument,
        addingDocument,
        savingDocument,
        rights,
        // getSingleDocument,
        addDocument,
        saveDocument,
        setSingleDocument,
    }
}

export default mapStateToProps;